import { apiClient } from '@shared/api/client';

/**
 * Entity 목록 조회 (공통 엔드포인트)
 */
export const getEntities = async () => {
  const response = await apiClient.get('/startTask/common/entities');
  return response;
};

/**
 * Position 목록 조회 (공통 엔드포인트)
 * @param entityCd - Entity 코드
 */
export const getPositions = async (entityCd: string) => {
  const response = await apiClient.get(`/startTask/common/positions/${entityCd}`);
  return response;
};

/**
 * Officer Name 목록 조회 (공통 엔드포인트)
 */
export const getOfficers = async () => {
  const response = await apiClient.get('/startTask/common/officers');
  return response;
};

/**
 * Entity별 Officer 목록 조회
 * @param entityCd - Entity 코드
 * @param positionCd - Position 코드
 */
export const getOfficersByEntity = async (entityCd: string, positionCd: string) => {
  const response = await apiClient.get(`/startTask/common/officers-by-entity/${entityCd}`, {
    params: { positionCd }
  });
  return response;
};

/**
 * Officer Cessation Task 생성
 * @param data - Task 생성 데이터
 */
export interface CreateOfficerCessationTaskRequest {
  entityCd: string;
  taskTypeCd: string;
  taskTypeName: string;
  taskTitle: string;
  taskFlow: {
    createDocument: boolean;
    requestTSign: boolean;
    proceedWithEFiling: boolean;
  };
  templateIds?: string[];
  officerData?: {
    officerName?: string;
    officerCode?: string;
    position?: string;
    positionCode?: string;
    dateOfCessation?: string;
    reasonForCessation?: string;
    otherReason?: string;
  };
}

export interface CreateOfficerCessationTaskResponse {
  taskId: number;
  taskTitle: string;
  templateMaps: Array<{
    tmpId: string;
    mapId: number;
  }>;
  docCustSaves: Array<{
    tmpId: string;
    mapId: number;
    saveId: number;
  }>;
  message: string;
}

export const createOfficerCessationTask = async (
  data: CreateOfficerCessationTaskRequest
) => {
  const response = await apiClient.post('/startTask/officer-cessation/tasks', data);
  return response;
};

